const $ = jQuery;
const postContainer = document.querySelector('.archive-recommendations__wrapper');
const posts = menaRecommendations.posts;

export default function archiveDialog() {
    bindClickEvents();
    bindDownloadButtonClickEvents();

    function bindClickEvents() {
        const adventItems = document.querySelectorAll('.card-recommendation, .related-article__link');

        adventItems.forEach((item) => {
            item.addEventListener('click', function (e) {
                e.preventDefault();

                let postId = this.getAttribute('data-post-id');

                if (!postId) {
                    console.log('No post ID for this item.');
                    return;
                }

                // Track Google Analytics event
                if (typeof gtag !== 'undefined') {
                    const post = posts.find((post) => post.id === parseInt(postId));
                    if (post) {
                        gtag('event', 'view_recommendation', {
                            event_category: 'recommendation_interaction',
                            event_label: post.title,
                            custom_parameters: {
                                post_id: postId,
                                post_title: post.title,
                                post_number: post.idNumber || '',
                                post_content: post.content || '',
                                recommendation_type: 'main_recommendation',
                            },
                        });
                    }
                }

                openDialog(postId);
            });
        });
    }
}

export function closeDialog() {
    slideDown(postContainer);
    document.body.classList.remove('single-is-open');

    setTimeout(() => {
        const dialogContent = document.getElementById('archive-dialog-content');
        if (dialogContent) {
            dialogContent.innerHTML = '';
        }
    }, 100);
}

const openDialog = (postId) => {
    const post = posts.find((post) => post.id === parseInt(postId));

    if (!post) {
        console.error('Post not found in local data.');
        return;
    }

    const archiveDialog = document.getElementById('archiveDialog');
    if (archiveDialog) {
        archiveDialog.innerHTML = prepareSingleRecommendationHtml(post);
        document.body.classList.add('single-is-open');
        slideUp(postContainer);

        const closeButton = document.getElementById('closeModalButton');
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                closeDialog();
            });
        }
    }

    archiveDialog.scrollIntoView({ behavior: 'smooth' });
    bindRelatedRecommendationClickEvents();
    bindDownloadButtonClickEvents();
};

const slideUp = (element) => {
    if (element) {
        const height = element.scrollHeight;
        element.style.height = height + 'px';
        element.dataset.height = height;

        setTimeout(() => {
            element.style.height = '0';
            element.style.overflow = 'hidden';
        }, 50);
    }
};

const slideDown = (element) => {
    if (element) {
        element.style.height = element.dataset.height + 'px';
        element.style.overflow = 'visible';

        setTimeout(() => {
            element.style.height = 'auto';
        }, 300);
    }
};

const prepareSingleRecommendationHtml = (post) => {
    const terms = JSON.parse(post.terms);
    let categories = terms.categories;
    categories = categories.split(',');
    categories = categories.map((category) => category.trim());
    categories = categories.filter((category) => category !== '');

    const relatedPosts = posts
        .filter((relatedPost) => {
            if (relatedPost.id === post.id) return false;
            const postTerms = JSON.parse(relatedPost.terms);
            const postCategories = postTerms.categories;
            return categories.some((category) => postCategories.includes(category));
        })
        .slice(0, 4);

    const relatedPostsHtml = prepareRelatedPostsHtml(relatedPosts);

    return `
    <div class="single-recommendations" data-post-id="${post.id}">
        <div class="single-recommendations__back flex align-center gap-xs pointer" id="closeModalButton">
            <svg width="5" height="9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 8 1 4.5 4 1" stroke="#ABABAB" stroke-width="1.5"/></svg>
            <p class="color-dark-grey">${post.labels.back || 'Go back'}</p>
        </div>

        <div class="single-recommendations__container flex">
            <div class="grid single-grid background-grey p-4 single-recommendations__left ${!post.image && !post.buttonsHtml ? 'single-recommendations__left--no-image' : ''}">
                <div class="single-recommendations__title color-primary">
                    <span class="mb-0 font-avenir body-small">${post.idNumber || ''}</span>
                    <span class="mb-1 font-extrabold body-md font-avenir">${post.title || ''}</span>
                    <div class="single-recommendations__content mb-0">${post.content || ''}</div>
                    <div class="mb-0">${post.buttonHtml || ''}</div>
                </div>

                ${
                    post.image || post.buttonsHtml
                        ? `
                    <div class="featured-image">
                        ${post.image ? `<img src="${post.image}" alt="${post.title}">` : ''}
                        <div class="buttons flex flex-col">${post.buttonsHtml || ''}</div>
                    </div>
                `
                        : ''
                }
            </div>
            <div class="single-recommendations__related-container flex flex-col justify-start align-center">
                <p class="color-dark-grey mb-4">Related recommendations</p>
                ${relatedPostsHtml}
            </div>
        </div>
    </div>
    `;
};

const prepareRelatedPostsHtml = (posts) => {
    if (!posts || posts.length === 0) {
        return '<p class="color-dark-grey">No related recommendations found.</p>';
    }

    let html = '<div class="related-articles flex flex-col gap-2">';

    html += posts
        .map(
            (post) => `
                        <a href="#" class="related-article background-grey radius-12 p-4 js-related-recommendation" data-post-id="${post.id}">
                            <div class="related-article__importance-level">
                                ${post.importanceLevel.map((level) => `<p class="body-small font-extrabold color-primary font-avenir" title="${level.name}">${level.letter}</p>`).join('')}
                            </div>
                            <span class="mb-0 color-primary font-avenir body-small">${post.idNumber || ''}</span>
                            <h4 class="color-primary">${post.title || ''}</h4>
                            ${post.buttons ? `<div class="related-article__badge">${post.badgeText || ''}</div>` : ''}
                            <div class="card-recommendation__button">
                                <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.7885 4.50006L7.25049 8.03906L6.53049 7.33106L8.86149 5.00006L0.211487 5.00006L0.211487 4.00006L8.86149 4.00006L6.53149 1.67006L7.25049 0.961063L10.7885 4.50006Z" fill="#155B8D"/>
                                </svg>
                            </div>
                        </a>
                    `,
        )
        .join('');

    html += '</div>';

    return html;
};

const bindRelatedRecommendationClickEvents = () => {
    const relatedRecommendations = document.querySelectorAll('.js-related-recommendation');

    relatedRecommendations.forEach((recommendation) => {
        recommendation.addEventListener('click', (e) => {
            e.preventDefault();

            const postId = recommendation.getAttribute('data-post-id');

            if (!postId) {
                console.log('No post ID for this item.');
                return;
            }

            // Track Google Analytics event for related recommendations
            if (typeof gtag !== 'undefined') {
                const post = posts.find((post) => post.id === parseInt(postId));
                if (post) {
                    gtag('event', 'view_related_recommendation', {
                        event_category: 'recommendation_interaction',
                        event_label: post.title,
                        custom_parameters: {
                            post_id: postId,
                            post_title: post.title,
                            post_number: post.idNumber || '',
                            post_content: post.content || '',
                            recommendation_type: 'related_recommendation',
                        },
                    });
                }
            }

            openDialog(postId);
        });
    });
};

const bindDownloadButtonClickEvents = () => {
    const downloadButtons = document.querySelectorAll('.js-download-button');

    downloadButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            // Track Google Analytics event for download button clicks
            if (typeof gtag !== 'undefined') {
                const postId = button.closest('[data-post-id]')?.getAttribute('data-post-id');
                if (!postId) {
                    console.log('No post ID for this item.');
                    return;
                }

                const post = postId ? posts.find((post) => post.id === parseInt(postId)) : null;
                if (!post) {
                    console.log('Post not found in data.');
                    return;
                }

                gtag('event', 'download_clicked', {
                    event_category: 'recommendation_interaction',
                    event_label: post ? post.title : 'unknown',
                    custom_parameters: {
                        post_id: postId || 'unknown',
                        post_title: post ? post.title : 'unknown',
                        post_number: post ? post.idNumber || '' : '',
                        download_url: button.href || button.getAttribute('href') || '',
                        recommendation_type: 'download_button',
                    },
                });
            }
        });
    });
};
